import { CommonUtilities } from 'commonUtils';
import React, { useEffect, useState } from 'react';
import Drawer from 'react-modern-drawer';

export default function ContractStatusUpsert(param: any) {

    let [contractStatus, setContractStatus] = useState<any>(param?.editDataDawer ?? []);

    console.log(param)

    const closeDrawer = () => { param.closeDrawer(); }

    const onReset = () => {
        console.log(param?.editDataDawer)
        if (param?.editDataDawer) {
            contractStatus = param?.editDataDawer
            setContractStatus(contractStatus)
        }
    }

    const onSave = () => {
        systemFormatsList.saveContractStatus(contractStatus).then((respond: any) => {
            CommonUtilities.showToastDawer('Contract Status Saved', 'Success')
        })
    }

    return (<>
        <Drawer open={param.openUpsertUX} direction='right' className='react-drawer allowHscroll' size={800}>

            <div className="pull-right ws-5 box full-height-vh" >

                <div className="ws-12 bg-blue ">
                    <h1 className="pull-left text-center mt mll">Add Contract Status</h1>
                    <i className="icon-close pull-right pLarge" onClick={closeDrawer}></i>
                </div>

                <div className="box-content">

                    <div className="ws-12">
                        <div className="ws-12 mbl">
                            <div className="form-format">
                                <label className="control-label" >Contract Status</label>
                                <div className="label-entries">
                                    <input type="number" placeholder="Contract Status" value={contractStatus?.contractStatus ?? ""} onChange={(e: any) => setContractStatus({ ...contractStatus, contractStatus: e.target.value })} id="contractStatus" name="contractStatus" />
                                </div>
                            </div>
                        </div>

                        <div className="ws-12 mb">
                            <div className="form-format">
                                <label className="control-label">Contract Status Name</label>

                                <div className="label-entries">
                                    <input type="text" placeholder="Contract Status Name" value={contractStatus?.statusName ?? ""} onChange={(e: any) => setContractStatus({ ...contractStatus, statusName: e.target.value })} id="statusName" name="statusName" />
                                </div>
                            </div>
                        </div>

                        <div className="ws-12">

                            <div className="ws-6 ptl ">
                                <span className='ws-12 text-bold pb'>Show on Account Summary</span>
                                <label className="switch mr">
                                    <input type="checkbox" onChange={(e: any) => setContractStatus({ ...contractStatus, ignoreAccSummary: !contractStatus?.ignoreAccSummary })} value={contractStatus?.ignoreAccSummary ? 1 : 0} checked={contractStatus?.ignoreAccSummary} />
                                    {contractStatus?.ignoreAccSummary == 1 && <span className="slider round text-left white pm pts">Yes</span>}
                                    {contractStatus?.ignoreAccSummary != 1 && <span className="slider round text-right white pm pts sliderOff">No</span>}
                                </label>
                            </div>

                            <div className="ws-6 ptl pbl">
                                <span className='ws-12 text-bold pb'>Use in Track Count</span>
                                <label className="switch mr">
                                    <input type="checkbox" onChange={(e: any) => setContractStatus({ ...contractStatus, splitsTable: !contractStatus?.splitsTable })} value={contractStatus?.splitsTable ? 1 : 0} checked={contractStatus?.splitsTable} />
                                    {contractStatus?.splitsTable == 1 && <span className="slider round text-left white pm pts">Yes</span>}
                                    {contractStatus?.splitsTable != 1 && <span className="slider round text-right white pm pts sliderOff">No</span>}
                                </label>
                            </div>

                            <div className="ws-6 ptl pbl">
                                <span className='ws-12 text-bold pb'>EmailYN</span>
                                <label className="switch mr">
                                    <input type="checkbox" onChange={(e: any) => setContractStatus({ ...contractStatus, emailYN: !contractStatus?.emailYN })} value={contractStatus?.emailYN ? 1 : 0} checked={contractStatus?.emailYN} />
                                    {contractStatus?.emailYN == 1 && <span className="slider round text-left white pm pts">Yes</span>}
                                    {contractStatus?.emailYN != 1 && <span className="slider round text-right white pm pts sliderOff">No</span>}
                                </label>
                            </div>

                            <div className="ws-6 ptl pbl">
                                <span className='ws-12 text-bold pb'> Default</span>
                                <label className="switch mr">
                                    <input type="checkbox" onChange={(e: any) => setContractStatus({ ...contractStatus, isDefault: !contractStatus?.isDefault })} value={contractStatus?.isDefault ? 1 : 0} checked={contractStatus?.isDefault} />
                                    {contractStatus?.isDefault == 1 && <span className="slider round text-left white pm pts">Yes</span>}
                                    {contractStatus?.isDefault != 1 && <span className="slider round text-right white pm pts sliderOff">No</span>}
                                </label>
                            </div>

                        </div>
                    </div>

                </div>

                {/* Footer */}
                <div className="box-footer ws-12 pull-right">
                    <button type="button" className="icon-btn delete pull-right" onClick={closeDrawer}>x Close</button>
                    <button type="button" className="icon-btn delete pull-right" onClick={onReset}>↻ Reset</button>
                    <button type="button" className="icon-btn edit pull-right" onClick={onSave}>✔ Save </button>
                </div>
            </div>

        </Drawer>
    </>)
}